export default "__VITE_ASSET__512408a4__"